export default "__VITE_ASSET__C61NuB4J__"